/**
 * Whether an appointment payload includes stock-affecting supply data.
 * @param {Array} supplyUsage
 * @param {Array} containerEvents
 * @returns {boolean}
 */
export function hasSupplyPayloadActivity(supplyUsage, containerEvents) {
  const usage = Array.isArray(supplyUsage) ? supplyUsage : [];
  for (const line of usage) {
    if (!line?.supplyId) continue;
    if (line.kind === 'quantity') {
      if (Number(line.quantity) > 0) return true;
    } else {
      return true;
    }
  }
  const events = Array.isArray(containerEvents) ? containerEvents : [];
  for (const event of events) {
    if (!event?.supplyId) continue;
    const opened = Math.max(0, Math.floor(Number(event.opened) || 0));
    const depleted = Math.max(0, Math.floor(Number(event.depleted) || 0));
    if (opened > 0 || depleted > 0) return true;
  }
  return false;
}

/**
 * Whether deleting should warn that stock was touched (no auto-reversal).
 * @param {object|null} appointment
 * @returns {boolean}
 */
export function hasInventoryStockImpact(appointment) {
  if (!appointment) return false;
  if (appointment.suppliesSkipped) return false;
  return hasSupplyPayloadActivity(appointment.supplyUsage, appointment.containerEvents);
}
